module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-zone-list component-backoffice-category-list"
  }, [_c('div', {
    staticClass: "row column"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.zones), function(zone, index) {
    return _c('div', {
      staticClass: "column small-12 large-6 category",
      class: {
        active: _vm.activeIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.setActive(index)
        }
      }
    }, [_c('div', {
      staticClass: "inner-content card text-center"
    }, [_c('div', {
      staticClass: "row text-center"
    }, [_c('div', {
      staticClass: "column text-left"
    }, [_c('h2', [_vm._v(_vm._s(zone.name) + "  ")])]), (_vm.activeIndex === index) ? _c('div', {
      staticClass: "column small-1"
    }, [_c('i', {
      staticClass: "fa fa-trash fa-2x",
      on: {
        "click": _vm.deleteZone
      }
    }), _c('i', {
      staticClass: "fa fa-edit fa-2x",
      on: {
        "click": _vm.editZone
      }
    }), _c('ModalReveal', {
      ref: "revealGeoJson",
      refInFor: true
    }, [_c('div', {
      staticClass: "text-right",
      attrs: {
        "slot": "trigger"
      },
      slot: "trigger"
    }, [_c('a', {
      staticClass: "fa-stack fa-md",
      attrs: {
        "title": "Copy GeoJson to clipboard"
      },
      on: {
        "click": _vm.showGeoJson
      }
    }, [_c('i', {
      staticClass: "fa fa-copy fa-2x fa-stack-1x fa-inverse"
    })])]), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column"
    }, [(_vm.spin) ? _c('loading-spinner') : _c('textarea', {
      attrs: {
        "id": "geoJsonToCopy",
        "rows": "30"
      },
      domProps: {
        "value": _vm.geoJson
      }
    })], 1)]), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('button', {
      staticClass: "button",
      attrs: {
        "disabled": _vm.geoJson == ''
      },
      on: {
        "click": _vm.copyToClipboard
      }
    }, [_vm._v("Copy to clipboard")])])])])], 1) : _vm._e()])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-863dcf12!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/ZoneList.vue
// module id = 2555
// module chunks = 1